module.exports = __webpack_public_path__ + "img/03-BABO-02.cb0e890a.png";